/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface FileGeneratorControllerDownloadKundendokumentV1$Params {
  kundendokumentId: number;
}

export function fileGeneratorControllerDownloadKundendokumentV1(http: HttpClient, rootUrl: string, params: FileGeneratorControllerDownloadKundendokumentV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, fileGeneratorControllerDownloadKundendokumentV1.PATH, 'get');
  if (params) {
    rb.path('kundendokumentId', params.kundendokumentId, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

fileGeneratorControllerDownloadKundendokumentV1.PATH = '/v1/file-generator/kundendokument/{kundendokumentId}/xlsx';
